import 'configurable-date-input-polyfill';
import NauiExplorer from './naui/pages/NauiExplorer.svelte';
import NauiIndex from './naui/pages/NauiIndex.svelte';
import NauiSnackbar from './naui/components/NauiSnackbar.svelte';

import KngCalendar from './kng/KngCalendar.svelte';

import ServicioDetalles from './kng/servicio/ServicioDetalles.svelte';
import ServicioEjecucion from './kng/servicio/ServicioEjecucion.svelte';
import ServicioEquipo from './kng/servicio/ServicioEquipo.svelte';

import Materiales from './kng/externas/Materiales.svelte';
import Movimiento from './kng/externas/Movimiento.svelte';
import Rentabilidad from './kng/externas/Rentabilidad.svelte';
import RentabilidadGlobal from './kng/externas/RentabilidadGlobal.svelte';
import RentabilidadServicios from './kng/externas/RentabilidadServicios.svelte';
import DetallesMovimiento from './kng/externas/DetallesMovimiento.svelte';

import DetallesBodega from './kng/internas/DetallesBodega.svelte';
import ReporteOcupacion from './kng/internas/ReporteOcupacion.svelte';
import ReporteMovimientos from './kng/internas/ReporteMovimientos.svelte';
import Bodegas from './kng/internas/Bodegas.svelte';
import ReporteBodegas from './kng/internas/ReporteBodegas.svelte';
import ReporteGeneral from './kng/internas/ReporteGeneral.svelte';

import Ventas from './kng/ventas/Ventas.svelte';
import InternaSolicitud from './kng/ventas/solicitud/InternaSolicitud.svelte';
import CotizacionM3 from './kng/ventas/cotizacion/CotizacionM3.svelte';
import CotizacionEmbalaje from './kng/ventas/cotizacion/CotizacionEmbalaje.svelte';
import CotizacionCajasVitrina from './kng/ventas/cotizacion/CotizacionCajasVitrina.svelte';
import CotizacionLogistica from './kng/ventas/cotizacion/CotizacionLogistica.svelte';
import CotizacionBodegaje from './kng/ventas/cotizacion/CotizacionBodegaje.svelte';
import CotizacionResumen from './kng/ventas/cotizacion/CotizacionResumen.svelte';

import MesAMes from './kng/comite/ventas/MesAMes.svelte';
import Cupos from './kng/comite/ventas/Cupos.svelte';
import Tendencia from './kng/comite/ventas/Tendencia.svelte';
import Visualizacion from './kng/comite/ventas/Visualizacion.svelte';
import Bonos from './kng/comite/Bonos.svelte';

export default {
    nauiExplorer: NauiExplorer,
    nauiIndex: NauiIndex,
    nauiSnackbar: NauiSnackbar,

    KngCalendar: KngCalendar,

    ServicioDetalles: ServicioDetalles,
    ServicioEjecucion: ServicioEjecucion,
    ServicioEquipo: ServicioEquipo,

    Materiales: Materiales,
    Movimiento: Movimiento,
    Rentabilidad: Rentabilidad,
    RentabilidadGlobal: RentabilidadGlobal,
    RentabilidadServicios: RentabilidadServicios,
    DetallesMovimiento: DetallesMovimiento,

    DetallesBodega: DetallesBodega,
    ReporteOcupacion: ReporteOcupacion,
    ReporteMovimientos: ReporteMovimientos,
    Bodegas: Bodegas,
    ReporteBodegas: ReporteBodegas,
    ReporteGeneral: ReporteGeneral,

    Ventas: Ventas,
    InternaSolicitud: InternaSolicitud,
    CotizacionM3: CotizacionM3,
    CotizacionEmbalaje: CotizacionEmbalaje,
    CotizacionCajasVitrina: CotizacionCajasVitrina,
    CotizacionLogistica: CotizacionLogistica,
    CotizacionBodegaje: CotizacionBodegaje,
    CotizacionResumen: CotizacionResumen,
    // InternaServicio: InternaServicio,

    MesAMes: MesAMes,
    Tendencia: Tendencia,
    Visualizacion: Visualizacion,
    Cupos: Cupos,
    Bonos: Bonos
};
